import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const id = params.get("escapade_id");
  return (
    <div data-testid="payment-cancel" className="px-4 max-w-xl mx-auto py-24 text-center">
      <XCircle className="w-10 h-10 text-gray-400 mx-auto" />
      <h1 className="mt-5 font-serif text-3xl font-bold text-[#0B131E]">Paiement annulé</h1>
      <p className="mt-3 text-gray-600">Aucun montant n'a été débité. Votre escapade vous attend toujours.</p>
      <Link to={id ? `/escapade/${id}` : "/"} data-testid="cancel-back-btn" className="mt-8 inline-flex h-11 px-6 items-center rounded-full bg-[#0B131E] text-white text-sm font-semibold hover:bg-amber-600 transition-colors">
        Revenir à l'escapade
      </Link>
    </div>
  );
}
